export default "https://cdn-static.gokick.com/assets/31e0b9f53043906ee01608417204ccf2abfa2ab1/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";